import Hero from "../components/site/Hero";
import {
  ServicesTeaser,
  AboutTeaser,
  CareersTeaser,
  ContactTeaser,
} from "../components/site/HomeTeasers";

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesTeaser />
      <AboutTeaser />
      <CareersTeaser />
      <ContactTeaser />
    </>
  );
}
